/**
 * IconCircle - The Intelligent Standard
 *
 * Circular background wrapper for icons.
 * Used in empty states, error states, and status indicators.
 */

import { ReactNode } from 'react';

export interface IconCircleProps {
  icon: ReactNode;
  backgroundColor: string;
  size?: number;
}

export function IconCircle({
  icon,
  backgroundColor,
  size = 48,
}: IconCircleProps) {
  return (
    <div
      className="rounded-full flex items-center justify-center mx-auto mb-4"
      style={{
        width: size,
        height: size,
        background: backgroundColor,
      }}
    >
      {icon}
    </div>
  );
}
